import React, { useState } from 'react'

import { Accordion } from 'react-bootstrap'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'

import { Typography } from '../index'

import * as S from './styles'

function CustomToggle({ eventKey }) {
  const [active, setActive] = useState(false)
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActive(!active)
  )

  return (
    <S.AccordionButton
      onClick={() => {
        decoratedOnClick()
        setActive(!active)
      }}
    >
      {active ? '-' : '+'}
    </S.AccordionButton>
  )
}

const AccordionDna = ({ data }) => {
  return (
    <div style={{ width: '100%' }}>
      <Accordion defaultActiveKey="">
        {data?.map?.((item) => (
          <S.AccordionItem key={item.eventKey}>
            <S.Header>
              <CustomToggle eventKey={item.eventKey} />
              <Typography type="title" spacing="0 0 0 26px">
                {item.title}
              </Typography>
            </S.Header>
            <Accordion.Collapse eventKey={item.eventKey}>
              <Typography type="text" spacing="0 0 20px 40px" color="#7A7786">
                {item.text}
              </Typography>
            </Accordion.Collapse>
          </S.AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}

export default AccordionDna
